import { render, staticRenderFns } from "./BernoulliLiftViz.vue?vue&type=template&id=1cbfc7ce&scoped=true"
import script from "./BernoulliLiftViz.vue?vue&type=script&lang=js"
export * from "./BernoulliLiftViz.vue?vue&type=script&lang=js"
import style0 from "./BernoulliLiftViz.vue?vue&type=style&index=0&id=1cbfc7ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbfc7ce",
  null
  
)

export default component.exports